import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import { createI18n } from 'vue-i18n'

import $ from 'jquery';
import L10n from '@limegreendigital/l10n-js'
import QRCode from "./lib/QRCode";

L10n.boot({
    language: window.jsLocale,
    region: window.jsLocale,
})
window.L10n = L10n

window.i18n = createI18n({
    locale: window.jsLocale,
    fallbackLocale: window.jsLocale,
    messages: window.jsMessages,
    legacy: false,
})

window.$t = function (key, values, choice) {
    const globalI18n = window.i18n && window.i18n.global;
    if (globalI18n && typeof globalI18n.t === 'function') {
        return globalI18n.t(key, values, choice);
    }

    return key;
}


$(document).ready(function () {
    tippy('.tooltip-box', {
        arrow: true,
        content: (ref) => {
            return '<p class="text-center margin-b-0 tippy-title"><strong>' + ref.getAttribute('alt') + '</strong></p><p><small>' + ref.dataset.title + '</small></p><hr>'
        },
        allowHTML: true,
        maxWidth: 245,
    });
    window.TABSlogin.checkStudentAuth();
});

$(document).on('submit', '#login_form', function (e) {
    window.TABSlogin.submitLogin(e)
});

$(document).on('submit', '#forgot_password_form', function (e) {
    window.TABSlogin.submitResetPassword(e)
})

$(document).on('submit', '#login_form_student', function (e) {
    window.TABSlogin.submitStudentLogin(e)
})

$(document).on('submit', '#login_form_company_contact', function (e) {
    window.TABSlogin.submitStudentLogin(e)
})

$(document).on('submit', '#forgot_password_form_student', function (e) {
    window.TABSlogin.submitStudentForgotPassword(e)
})

window.TABSlogin = {
    submitLogin: function (e) {
        e.preventDefault();

        $('.feedback-wrapper').hide();
        const $loginButton = $('#login_form').find('input[type=submit]');
        const $form = $('#login_form');
        $loginButton.prop('disabled', true);

        $.ajax({
            url: "/login",
            dataType: "json",
            method: 'post',
            crossDomain: false,
            data: $form.serialize()
        }).done(function (response) {
            const credentials = JSON.stringify({
                username: $form.find('input[name=login]').val(),
                password: $form.find('input[name=password]').val(),
                auth_key: response.auth_key,
                redirect_uri: $form.find('input[name=redirect_uri]').val(),
                s_id: response.s_id,
            })
            if (response.status === 'ok') {
                // Correct credentials store
                if (typeof window.storeAppCredentials === 'object') {
                    window.storeAppCredentials.postMessage(credentials);
                }
                window.location.href = response.redirect;
                return;
            }
            if (response.require === '2fa') {
                // Correct credentials store
                if (typeof window.storeAppCredentials === 'object') {
                    window.storeAppCredentials.postMessage(credentials);
                }
                $('#2fa').removeClass('hide');
            }
            $('.feedback-wrapper').removeClass('alert-info').addClass('alert-danger').html(response.message).fadeIn();
            setTimeout(function () { $loginButton.prop('disabled', false); }, 500);
        }).fail(function (e) {

            $loginButton.prop('disabled', false);

            let message = $t('Det skjedde noe galt. Prøv igjen senere.')
            if (e.status > 399 && e.status < 500 && e.responseJSON && e.responseJSON.message) {
                message = e.responseJSON.message
            }
            $('.feedback-wrapper').removeClass('alert-info').addClass('alert-danger').html(message).fadeIn();
        });
    },
    submitStudentLogin: function (e) {
        e.preventDefault();

        const $loginButton = $(e.target);
        const $form = $loginButton.closest('form');
        $('.feedback-wrapper').hide();
        $loginButton.prop('disabled', true);

        $.ajax({
            url: $form.attr('action'),
            dataType: "json",
            contentType: "application/json",
            method: 'post',
            xhrFields: {
                withCredentials: true,
            },
            data: JSON.stringify({
                mobile: $form.find('input[name=mobile]').val(),
                password: $form.find('input[name=password]').val(),
                countryCode: $form.find('input[name=country_code').val(),
                t: $form.find('input[name=security_check]').val(),
                authKey: $form.find('input[name=auth_key]').val(),
                biometricLogin: $form.find('input[name=biometric_login]').val(),
                companyContact: $form.find('input[name=company_contact]').val(),
                companyId: $form.find('input[name=company_id]').val(),
            }),
        }).done(function (response) {
            if (response.status === 'ok') {
                if (typeof window.storeAppCredentials === 'function') {
                    window.storeAppCredentials($form.find('input[name=mobile]').val(), $form.find('input[name=password]').val());
                } else if (typeof window.storeAppCredentialsCC === 'function') {
                    window.storeAppCredentialsCC($form.find('input[name=mobile]').val(), $form.find('input[name=password]').val(), $form.find('input[name=country_code]').val());
                }

                if (response.redirect) {
                    window.location.href = response.redirect;
                    return;
                }

                window.location.href = $('input#student-domain').val();
                return;
            }
            $('.feedback-wrapper').removeClass('alert-info').removeClass('alert-success').removeClass('alert-warning').addClass('alert-danger').html(response.message).fadeIn();
            setTimeout(function () { $loginButton.prop('disabled', false); }, 500);
        }).fail(function (e) {
            $loginButton.prop('disabled', false);

            let message = $t('Det skjedde noe galt. Prøv igjen senere.')
            if (e.status > 399 && e.status < 500 && e.responseJSON && e.responseJSON.message) {
                message = e.responseJSON.message
            }

            $('.feedback-wrapper').removeClass('alert-info').removeClass('alert-success').removeClass('alert-warning').addClass('alert-danger').html(message).fadeIn();
        });
    },
    toggleForgotPassword: function (e, login, title) {
        e.preventDefault();

        if (login) {
            const mobilenumber = $('#login_form .mobile-input, #login_form_student .mobile-input').val()
            if (mobilenumber.length) {
                $('#forgot_password_form .mobile-input, #forgot_password_form_student .mobile-input').val(mobilenumber)
            }
            $('#login_form, #login_form_student').hide();
            $('#forgot_password_form, #forgot_password_form_student').show();
        } else {
            $('#login_form, #login_form_student').show();
            $('#forgot_password_form, #forgot_password_form_student').hide();
            if (title) {
                $('#forgot_password_form_student h4 strong').text(title);
            }
        }
    },

    toggleMinimalMobileLogin: function (e) {
        e.preventDefault();
        $('#login_form, #login_form_student').show();
        $('#minimal-mobile-login-wrapper').hide();
    },

    toggleQrLogin: function (e, open, hash) {
        e.preventDefault();

        if (open) {
            let is_mobile = $('#login_form').find('input[name=is_mobile]').val()
            if (is_mobile) {
                return window.location.href = '/login/qr/verify/' + hash;
            }
            $('#login_form, #login_form_student, #qr-login-timeout-prompt').hide();
            $('#qr-wrapper').show();
            window.TABSlogin.checkQrLogin(hash, 0)
            return;
        }

        $('#login_form, #login_form_student').show();
        $('#qr-wrapper').hide();
    },

    toggleQrLoginTimeout: function (hash = '') {
        if ($('#qr-login-timeout-prompt').is(':visible')) {
            window.TABSlogin.checkQrLogin(hash, 0);
            $('#qr-login-timeout-prompt').hide();
            return;
        }
        $('#qr-login-timeout-prompt').show();
    },

    checkQrLogin: function (hash, checked) {
        $.ajax({
            type: 'get',
            dataType: 'json',
            url: '/login/qr/check/' + hash,
            success: function (data) {
                if (data.success === 1) {
                    location.reload();
                } else if (checked < 60 && $('#qr-wrapper').is(':visible')) { // keep checking for aprox 2 min, or user cancels qr-login
                    setTimeout(function () { window.TABSlogin.checkQrLogin(hash, checked + 1) }, 2000); // 2 sec
                } else {
                    window.TABSlogin.toggleQrLoginTimeout(hash);
                }
            }
        });
    },

    submitResetPassword: function (e) {
        e.preventDefault();
        $('.feedback-wrapper').hide();
        $.ajax({
            url: "/reset_password",
            dataType: "json",
            method: 'post',
            crossDomain: false,
            data: $('#forgot_password_form').serialize()
        })
            .done(function (response) {
                switch (response.status) {
                    case 'ok':
                        window.location = '/login/1';
                        break;
                    case -1:
                        $('.feedback-wrapper').removeClass('alert-info').removeClass('alert-warning').addClass('alert-danger').text(response.message).fadeIn();
                        break;
                    default:
                        $('.feedback-wrapper').removeClass('alert-info').removeClass('alert-danger').addClass('alert-warning').text(response.message).fadeIn();
                        break;
                }
            });
    },
    submitStudentForgotPassword: function (e) {
        e.preventDefault();
        $('.feedback-wrapper').hide();
        var $form = $('#forgot_password_form_student');
        var $button = $form.find('input[type=submit]');

        let dof = $form.find('input[name=date_of_birth]')
        if (!dof.hasClass('d-none') && dof.val().length && !validateDate(dof[0])) {
            $('.feedback-wrapper').removeClass('alert-info').removeClass('alert-warning').removeClass('alert-success').addClass('alert-danger').text($t('Feil datoformat.')).fadeIn();
            return;
        }

        $button.prop('disabled', true);
        $.ajax({
            url: $('#forgot_password_form_student').attr('action'),
            dataType: "json",
            method: 'post',
            xhrFields: {
                withCredentials: true,
            },
            data: JSON.stringify({
                mobile: $form.find('input[name=password_reset]').val(),
                dateOfBirth: $form.find('input[name=date_of_birth]').val(),
                countryCode: $form.find('input[name=country_code]').val(),
                t: $form.find('input[name=security_check]').val(),
            }),
        }).done(function (response) {
            $button.prop('disabled', false);
            if (response.required === 'DateOfBirth') {
                $('.feedback-wrapper').removeClass('alert-info').removeClass('alert-success').removeClass('alert-danger').addClass('alert-warning').text(response.message).fadeIn();
                $form.find('input[name=date_of_birth]').parent('.form-group').removeClass('d-none');
                $form.find('input[name=password_reset]').val()
                return;
            }
            if (response.success) {
                $('.feedback-wrapper').removeClass('alert-info').removeClass('alert-warning').removeClass('alert-danger').addClass('alert-success').text(response.message).fadeIn();
                window.TABSlogin.toggleForgotPassword(e, false);
                $form.find('input[name=date_of_birth]').empty().parent('.form-group').addClass('d-none');
                const mobile = $form.find('input[name=password_reset]').val()
                if (mobile.length) {
                    $('#login_form_student .mobile-input').val(mobile);
                }
                return;
            }

            $('.feedback-wrapper').removeClass('alert-info').removeClass('alert-warning').removeClass('alert-success').addClass('alert-danger').text(response.message).fadeIn();

        }).fail(function (error) {
            $button.prop('disabled', false);
            $('.feedback-wrapper').removeClass('alert-info').addClass('alert-danger').text($t('Det skjedde noe galt. Prøv igjen senere.')).fadeIn();
        });
    },
    checkStudentAuth: function () {
        if (!$('input#login-status').length) {
            return;
        }
        const loginStatus = $('input#login-status').val();
        const studentDomain = $('input#student-domain').val();
        $.ajax({
            url: loginStatus,
            method: 'GET',
            xhrFields: {
                withCredentials: true,
            },
        }).done(function (res) {
            if (res.authed && studentDomain.length > 0) {
                window.location.href = studentDomain;
            } else if (res.biometrics_enabled) {
                window.TABSlogin.triggerBiometric();
            }
        });
    },
    toggleExpandAll: function (el) {
        $('.expandable-features').toggleClass('max-height-0').toggleClass('max-height-5000');
        $(el).remove();
    },
    /** @deprecated - Remove after we force build number ^48 of teacher app and ^64 of student app **/
    insertCredentialsAndSubmit: function (username, password, auth_key) {
        let $loginForm = $('form#login_form_student');
        if (!$loginForm.length) {
            $loginForm = $('form#login_form')
        }
        $loginForm.find('input[name=biometric_login]').val(1);
        $loginForm.find('input[name=mobile],input[name=login]').val(username);
        $loginForm.find('input[name=password]').val(password);
        $loginForm.find('input[name=auth_key]').val(auth_key);
        $loginForm.submit();
    },
    insertAuthKeyAndSubmit: function (auth_key) {
        let loginForm = $('form#login_form')
        if (!loginForm.length) {
            loginForm = $('form#login_form_student');
            loginForm.find('input[name=mobile]').removeAttr('required');
            loginForm.find('input[name=password]').removeAttr('required');
        }
        loginForm.find('input[name=biometric_login]').val(1);
        loginForm.find('input[name=auth_key]').val(auth_key);
        loginForm.submit();
    },
    triggerBiometric: function () {
        if ((navigator.userAgent.indexOf('|TABSapp') > -1 || navigator.userAgent.indexOf('|TABSteacher') > -1) && $('input#biometrics').val() === '1') {
            window.TABSlogin.forceTriggerBiometric()
        }
    },
    forceTriggerBiometric: function () {
        if (typeof window.attemptBiometricAuth === 'object') {
            window.attemptBiometricAuth.postMessage(JSON.stringify({ attemptBioAuth: true }));
        } else {
            console.log(JSON.stringify({ attemptBioAuth: true }));
        }
    },
    showBiometricButton: function (faceId) {
        $('#biometric-login-button').removeClass('hide')
        $('#primary-biometric-login-button').removeClass('hide')
        $('#choose-other-login').removeClass('hide')
        $('#goto-login-button').addClass('hide');
        if (faceId) {
            $('.js-face-id-icon').removeClass('hide')
        } else {
            $('.js-fingerprint-icon').removeClass('hide')
        }
    },
    GenerateQRCodeForCanvas: function (canvas, alert) {
        QRCode.generateQRCodeForCanvas(canvas, alert);
    },
    goToLogin: function () {
        $('#login_form').toggle();
        $('#login_or_qr_form').toggle();
    },
    confirmQrLogin: function (hash, logout, redirect_to_web) {
        const button = document.getElementById('confirm-qr-login-button')
        const errEl = document.getElementById('confirm-qr-login-error');
        if (button.classList.contains('disabled')) {
            return;
        }

        button.classList.add('disabled')
        $.post('/login/qr/confirm/' + hash)
            .done(function (res) {
                button.classList.remove('disabled')
                if (res.success) {
                    if (redirect_to_web === '1') {
                        return TSP.routing.changePage('/login/qr/redirect/' + hash + '?logout=' + logout);
                    } else if (logout === '1') {
                        return TSP.routing.changePage('/logout');
                    }
                    return TSP.routing.changePage('/');
                }
                errEl.classList.remove('d-none')
                errEl.innerText = res.message
            })
            .error(function (e) {
                button.classList.remove('disabled')
                let message = $t('Det skjedde noe galt. Prøv igjen senere.')
                if (e.status > 399 && e.status < 500 && e.responseJSON && e.responseJSON.message) {
                    message = e.responseJSON.message
                }

                errEl.classList.remove('d-none')
                errEl.innerText = message
            });
    },
}

window.validateDate = function (dateInput) {
    if (!dateInput.value.length) {
        return false;
    }
    let birthdate = L10n.date.parse(dateInput.value);
    if (birthdate.isValid()) {
        dateInput.value = birthdate.format();
    }
    return birthdate.isValid();
}
